import { MetaRoot } from 'util/metaPath'
import {
  AtividadeColetivaFilterFormModel,
  AtividadeColetivaFonteEnum,
} from 'view/atividade-coletiva/model-atividadeColetiva'

export const createAtividadeColetivaFilterFormCalculations = (path: MetaRoot<AtividadeColetivaFilterFormModel>) => [
  {
    field: path.fonteRegistros.absolutePath(),
    updates: {
      [path.isProcessado.absolutePath()]: (
        value: AtividadeColetivaFonteEnum,
        allValues: AtividadeColetivaFilterFormModel
      ) => (value === AtividadeColetivaFonteEnum.OUTROS ? undefined : allValues.isProcessado),
    },
  },
]
